"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listUsers = exports.listElements = exports.groupAndSortUsers = exports.groupAndSortSubField = void 0;
var end2end_1 = require("@hudled/end2end");
var flow_1 = __importDefault(require("lodash/fp/flow"));
var groupBy_1 = __importDefault(require("lodash/fp/groupBy"));
var map_1 = __importDefault(require("lodash/fp/map"));
var reverse_1 = __importDefault(require("lodash/fp/reverse"));
var sortBy_1 = __importDefault(require("lodash/fp/sortBy"));
var groupAndSortSubField = function (objects, subField, groupField) { return (0, flow_1.default)((0, map_1.default)(Array.isArray(subField) ? subField.join('.') : subField), (0, groupBy_1.default)(groupField), (0, map_1.default)(function (userGroup) { return ({ count: userGroup.length, element: userGroup[0] }); }), (0, sortBy_1.default)('count'), reverse_1.default, (0, map_1.default)('element'))(objects); };
exports.groupAndSortSubField = groupAndSortSubField;
var groupAndSortUsers = function (notifications) { return ((0, exports.groupAndSortSubField)(notifications, 'sourceUser', 'id')); };
exports.groupAndSortUsers = groupAndSortUsers;
// export const groupAndSortDepartments = (notifications: PopulatedNotification[]): string[] => (
//   groupAndSortSubField<PopulatedNotification, string>(
//     notifications,
//     (notif) => notif.serviceStat?.department || notif.service?.department,
//   )
// );
var listElements = function (elements) {
    if (elements.length === 0)
        return '';
    if (elements.length === 1)
        return elements[0];
    if (elements.length === 2)
        return "".concat(elements[0], " and ").concat(elements[1]);
    return "".concat(elements[0], " and ").concat(elements.length - 1, " others");
};
exports.listElements = listElements;
var listUsers = function (users) { return (0, exports.listElements)(users.map(end2end_1.getFirstName)); };
exports.listUsers = listUsers;
